import React from 'react';
type ToggleProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};
export function Toggle({
  label,
  checked,
  onChange
}: ToggleProps) {
  return <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={`relative h-[11px] w-[20px] shrink-0 rounded-full transition-colors duration-150 ${checked ? 'bg-pf-blue' : 'bg-[#5b6066]'}`} data-id="element-878" data-mp="17xnj6i4bezwk">
      
      <span className="absolute top-[2px] h-[7px] w-[7px] rounded-full bg-white transition-transform duration-150" style={{
      left: 2,
      transform: checked ? 'translateX(9px)' : 'translateX(0)',
      transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
    }} data-id="element-879" data-mp="12yu78u4ofgyi" />
      
    </button>;
}